import { render, staticRenderFns } from "./LogbookReport.vue?vue&type=template&id=0f188147&scoped=true&"
import script from "./LogbookReport.vue?vue&type=script&lang=js&"
export * from "./LogbookReport.vue?vue&type=script&lang=js&"
import style0 from "./LogbookReport.vue?vue&type=style&index=0&id=0f188147&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f188147",
  null
  
)

export default component.exports